import * as endpoints from "../constants/api-constants"
import { axiosInstance } from "./axios-instance"

class MyPointsService {
  static postMyKeys(payload, productGeneric, config) {
    payload.country = parseInt(process.env.COUNTRY_CODE)
    if (productGeneric) {
      return axiosInstance.post(endpoints.postMyKeys + "?productGeneric=" + productGeneric, payload, config).then(resp => resp.data)
    } else {
      return axiosInstance.post(endpoints.postMyKeys, payload, config).then(resp => resp.data)
    }

  }

  static getPrices() {
    return axiosInstance.get(endpoints.getPrices + "?country=" + process.env.COUNTRY_CODE).then(resp => resp.data)
  }

  static getListAccumulated(page, size, initialDate, finalDate, config) {
    return axiosInstance.get(endpoints.getAccumulations + "?&page=" + page + "&size=" + size + "&initialDate=" + initialDate + "&finalDate=" + finalDate + "&country=" + process.env.COUNTRY_CODE, config).then(resp => resp.data)
  }

  static getListActivity(page, size, initialDate, finalDate, config) {
    return axiosInstance.get(endpoints.getActivity + "?&page=" + page + "&size=" + size + "&initialDate=" + initialDate + "&finalDate=" + finalDate + "&country=" + process.env.COUNTRY_CODE, config).then(resp => resp.data)
  }

  static getListOrders(page, size, initialDate, finalDate, config) {
    return axiosInstance.get(endpoints.getOrders + "?&page=" + page + "&size=" + size + "&initialDate=" + initialDate + "&finalDate=" + finalDate + "&country=" + process.env.COUNTRY_CODE, config).then(resp => resp.data)
  }

  // static getListSamplesVConfident(config) {
  static getListSamplesVConfident(page, size, initialDate, finalDate, config) {
    return axiosInstance.get(endpoints.getSamplesVConfidnet + "?&page=" + page + "&size=" + size + "&initialDate=" + initialDate + "&finalDate=" + finalDate, config).then(resp => resp.data)
    // return axiosInstance.get(endpoints.getSamplesVConfidnet, config).then(resp => resp.data)
  }

  static downLoadPdf(redemptionId, config) {
    return axiosInstance.get(endpoints.downloadPdf + "?redemptionId=" + redemptionId + "&country=" + process.env.COUNTRY_CODE, config)
  }

  static getPointsAccumulated(config) {
    return axiosInstance.get(endpoints.pointsAccumulated + "?country=" + process.env.COUNTRY_CODE, config).then(resp => resp.data)
  }

  static getQuantitiyPrice(cmsId) {
    return axiosInstance.get(endpoints.getPrice + "?cmsId=" + cmsId + "&country=" + process.env.COUNTRY_CODE).then(resp => resp.data)
  }

  static getKeyProduct(key, config) {
    return axiosInstance.get(endpoints.getProduct + "?key=" + key, config).then(resp => resp.data)
  }
}

export default MyPointsService
